/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Role_WdInputs */

const en_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Developer`)
};

const ar_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور ويب`)
};

const bn_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়েব ডেভেলপার`)
};

const de_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webentwickler`)
};

const es_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador web`)
};

const fr_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur Web`)
};

const pt_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor Web`)
};

const zh_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网页开发人员`)
};

const tr_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Geliştiricisi`)
};

const ru_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Веб-разработчик`)
};

const pl_resume_role_wd = /** @type {(inputs: Resume_Role_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twórca stron internetowych`)
};

/**
* | output |
* | --- |
* | "Web Developer" |
*
* @param {Resume_Role_WdInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_role_wd = /** @type {((inputs?: Resume_Role_WdInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Role_WdInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_role_wd(inputs)
	if (locale === "bn") return bn_resume_role_wd(inputs)
	if (locale === "de") return de_resume_role_wd(inputs)
	if (locale === "es") return es_resume_role_wd(inputs)
	if (locale === "fr") return fr_resume_role_wd(inputs)
	if (locale === "pt") return pt_resume_role_wd(inputs)
	if (locale === "zh") return zh_resume_role_wd(inputs)
	if (locale === "tr") return tr_resume_role_wd(inputs)
	if (locale === "ru") return ru_resume_role_wd(inputs)
	if (locale === "pl") return pl_resume_role_wd(inputs)
	return en_resume_role_wd(inputs)
});